'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _account = require('redux/modules/account');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailConfirm = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    addEmailConfirmError: state.account.addEmailConfirmLoadError,
    addEmailConfirmLoaded: state.account.addEmailConfirmLoaded,
    addEmailConfirmLoading: state.account.addEmailConfirmLoading,
    emailCode: ownProps.location.query.code,
    emailKey: ownProps.location.query.key
  };
}, { addEmailConfirm: _account.addEmailConfirm }), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EmailConfirm, _Component);

  function EmailConfirm() {
    (0, _classCallCheck3.default)(this, EmailConfirm);
    return (0, _possibleConstructorReturn3.default)(this, (EmailConfirm.__proto__ || (0, _getPrototypeOf2.default)(EmailConfirm)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmailConfirm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          emailKey = _props.emailKey,
          emailCode = _props.emailCode;

      this.props.addEmailConfirm(emailKey, emailCode);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          t = _props2.t,
          addEmailConfirmLoading = _props2.addEmailConfirmLoading,
          addEmailConfirmLoaded = _props2.addEmailConfirmLoaded,
          addEmailConfirmError = _props2.addEmailConfirmError;


      return _react2.default.createElement(
        'div',
        { className: 'compactContent' },
        _react2.default.createElement(_reactHelmet2.default, { title: t('Confirm email') }),
        _react2.default.createElement(
          'h1',
          null,
          t('Confirm email address')
        ),
        addEmailConfirmLoading && _react2.default.createElement(_components.Loader, null),
        addEmailConfirmLoaded && _react2.default.createElement(
          'div',
          { className: 'h3 colorSuccess' },
          t('Email was successfully added')
        ),
        addEmailConfirmError && _react2.default.createElement(
          'div',
          { className: 'colorError' },
          addEmailConfirmError.msg
        )
      );
    }
  }]);
  return EmailConfirm;
}(_react.Component), _class2.propTypes = {
  addEmailConfirm: _propTypes2.default.func,
  addEmailConfirmError: _propTypes2.default.object,
  addEmailConfirmLoaded: _propTypes2.default.bool,
  addEmailConfirmLoading: _propTypes2.default.bool,
  emailCode: _propTypes2.default.string,
  emailKey: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp)) || _class) || _class);
exports.default = EmailConfirm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EmailConfirm/EmailConfirm.js
// module id = 2157
// module chunks = 1